export class ProvideTrendUrls {
  // TODO : once we have a full single page app this should be retrievable from vue-router

  fromTemplate(templateId: string): string {
    return `${window.origin}/#/templates/${templateId}`;
  }
}
